import React from "react";
import { downloadImage } from "shared/data";
import * as notify from "shared/notify";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const DownloadImage = ({ sourcePage, title, wipKey, shotKey, type, showIconOnly, isReadOnly }) => {
    const path = `/photography/wips/${wipKey}/wip-shots/${type}/${shotKey}`;

    const linkClick = async () => {
        const file = await downloadImage(path, sourcePage);

        if (!file) {
            return notify.error("You do not have permission to perform this action.");
        }

        return file;
    };

    return (
        <button
            className={showIconOnly ? "" : classnames("button", { "-disabled": isReadOnly })}
            title={title}
            onClick={linkClick}
            disabled={isReadOnly}
        >
            <FontAwesomeIcon icon={faDownload} />
        </button>
    );
};

export default DownloadImage;
